const setAuthentication = ({ unit, assembly, role, access_token }) => {
    localStorage.setItem('Authenticated', true);
    localStorage.setItem('unit', JSON.stringify(unit));
    localStorage.setItem('assembly', JSON.stringify(assembly));
    localStorage.setItem('role', JSON.stringify(role));
    localStorage.setItem('accessToken', access_token);
};

const removeTokens = () => {
    localStorage.removeItem('Authenticated');
    localStorage.removeItem('unit');
    localStorage.removeItem('assembly');
    localStorage.removeItem('role');
    localStorage.removeItem('accessToken');
};
const getAuthenticated = () => localStorage.getItem('Authenticated');
const getunit = () => localStorage.getItem('unit');
const getassembly = () => localStorage.getItem('assembly');
const getrole = () => localStorage.getItem('role');
const seaccessToken = () => localStorage.setItem('accessToken');

module.exports = {
    setAuthentication,
    removeTokens,
    getAuthenticated,
    getunit,
    getassembly,
    getrole,
    seaccessToken,
};
